export const translations = {
  it: {
    select_sport_title: 'Seleziona la disciplina sportiva',
    select_sport_placeholder: 'Seleziona disciplina',
    select_model_title: 'Seleziona il modello del fucile',
    select_model_placeholder: 'Seleziona modello',
    select_handle_title: 'Seleziona la tua impugnatura',
    select_handle_placeholder: 'Seleziona impugnatura',
    select_handle_description_no_brand:
      'Selezionare prima il modello del fucile',
    select_grip_size_title: "Seleziona la taglia dell'impugnatura",
    select_grip_size_description_disabled:
      'Non è possibile modificare la taglia',
    select_grip_size_description_no_handle: "Selezionare prima l'impugnatura",
    select_grip_size_placeholder: 'Seleziona taglia',
    select_grip_type_title: "Seleziona la tipologia dell'impugnatura",
    select_grip_type_placeholder: 'Seleziona tipologia',
    select_pipe_size_title: 'Seleziona la dimensione del tubo',
    select_pipe_size_placeholder: 'Seleziona dimensione',
    select_pipe_size_description_no_handle_or_grip_size:
      "Selezionare prima l'impugnatura e la taglia",
    grip_type_left: 'Sinistro',
    grip_type_right: 'Destro',
    grip_size_xs: 'XS',
    grip_size_s: 'S',
    grip_size_m: 'M',
    grip_size_l: 'L',
    grip_size_xl: 'XL',
    grip_size_s_m_l: 'S, M, L',
    grip_size_I: 'I',
    grip_size_II: 'II',
    grip_size_none: 'Non ha taglia',
    grip_size_universal: 'Taglia unica',
    grip_size_custom: 'Taglia su richiesta',
    summary_card_title: 'Riepilogo prodotto',
    summary_card_title_code: 'Codice prodotto',
    summary_card_subtitle_1: 'Prodotto:',
    summary_card_subtitle_2: 'Componenti selezionati:',
    summary_card_btn: 'Richiedi preventivo',
    loader_label: 'Caricamento configuratore 3d in corso...',
  },
  en: {
    select_sport_title: 'Select the sport discipline',
    select_sport_placeholder: 'Select discipline',
    select_model_title: 'Select the speargun model',
    select_model_placeholder: 'Select model',
    select_handle_title: 'Select your handle',
    select_handle_placeholder: 'Select handle',
    select_handle_description_no_brand:
      'Please select the speargun model first',
    select_grip_size_title: 'Select the grip size',
    select_grip_size_description_disabled: 'Grip size cannot be changed',
    select_grip_size_description_no_handle: 'Please select the handle first',
    select_grip_size_placeholder: 'Select size',
    select_grip_type_title: 'Select grip type',
    select_grip_type_placeholder: 'Select type',
    select_pipe_size_title: 'Select tube size',
    select_pipe_size_placeholder: 'Select size',
    select_pipe_size_description_no_handle_or_grip_size:
      'Please select the handle and the grip size first',
    grip_type_left: 'Left-handed',
    grip_type_right: 'Right-handed',
    grip_size_I: 'I',
    grip_size_II: 'II',
    grip_size_xs: 'XS',
    grip_size_s: 'S',
    grip_size_m: 'M',
    grip_size_l: 'L',
    grip_size_xl: 'XL',
    grip_size_none: 'No size',
    grip_size_universal: 'One size',
    grip_size_custom: 'Size on request',
    summary_card_title: 'Product Summary',
    summary_card_title_code: 'Product Code',
    summary_card_subtitle_1: 'Product:',
    summary_card_subtitle_2: 'Selected components:',
    summary_card_btn: 'Request Quote',
    loader_label: 'Loading 3D configurator in progress...',
  },
};

export type Language = keyof typeof translations;
export type TranslationKey = keyof (typeof translations)['en'];
